import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import SnackBarState from "./state";
import SnackbarPayload from './payload';

export default createSlice({
  name: "snackbar",
  initialState: {
    isOpen: false,
    alert: {
      message: '',
      severity: 'info'
    }
  } as SnackBarState,
  reducers: {
    updateSnackBar: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        isOpen: action.payload
      }
    },
    updateAlert: (state, action: PayloadAction<SnackbarPayload>) => {
      return {
        ...state,
        alert: {
          message: action.payload.message,
          severity: action.payload.severity
        }
      }
    }
  },
});